import { useMemo } from 'react'
import { calcQuest } from '@prometheus/utils'
import { OwnedPlanets } from '@prometheus/types'
import { useSelector } from '../../../hooks/useSelector'
import { DEFAULT_FORECAST_YEARS, getResourceUsageForecast } from '../../../utils/getResourceUsageForecast'

const NO_PLANETS: OwnedPlanets = {}

/**
 * The player's resource forecast over `years` years: what their planets will
 * consume levelling up, what their mines will produce, and the resulting
 * deficit/surplus. Every view that shows a deficit reads it from here so they
 * cannot disagree.
 */
export const useResourceForecast = (years: number = DEFAULT_FORECAST_YEARS) => {
  const planets = useSelector(s => s.game.sheet?.planets) || NO_PLANETS
  const sheet_resources = useSelector(s => s.game.sheet?.resources)
  const cash = useSelector(s => s.game.sheet?.cash)
  const disable_planet_tokens = useSelector(s => s.game.options?.disable_planet_tokens)
  const planet_rolls_count = useSelector(s => s.game.options?.planet_rolls_count)
  const recession_modifier = useSelector(s => s.game.sheet?.recession_mine_production_modifier)
  const quest_production_bonus = useSelector(s => calcQuest(s.game.sheet?.quests?.rewards?.mine_production_multiplier || []))

  return useMemo(() => getResourceUsageForecast(planets, sheet_resources, cash, {
    years,
    disable_planet_tokens,
    planet_rolls_count,
    recession_modifier,
    quest_production_bonus,
  }), [
    planets,
    sheet_resources,
    cash,
    years,
    disable_planet_tokens,
    planet_rolls_count,
    recession_modifier,
    quest_production_bonus,
  ])
}
